import { Username } from '@model';

export interface Device {
  id: string;
  parentId: string;
  displayLabel: string;
  displayLabels: Record<string, string>;
  description: string;
  descriptions: Record<string, string>;
  status: string;
  timezone: string;
  locale: string;
  createdBy: Username;
  createdDate: string;
  lastUpdatedDate: string;
  spaceType: string;
}

export class Device {
  constructor() {
    this.id = '';
    this.parentId = '';
    this.displayLabel = '';
    this.displayLabels = {};
    this.description = '';
    this.descriptions = {};
    this.status = '';
    this.timezone = '';
    this.locale = '';
    this.createdBy = {} as any as Username;
    this.createdDate = '';
    this.lastUpdatedDate = '';
    this.spaceType = 'Site';
  }
}
